import { render, staticRenderFns } from "./flowList.vue?vue&type=template&id=48483a7e&scoped=true&"
import script from "./flowList.vue?vue&type=script&lang=js&"
export * from "./flowList.vue?vue&type=script&lang=js&"
import style0 from "./flowList.vue?vue&type=style&index=0&id=48483a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48483a7e",
  null
  
)

export default component.exports